var toastr = require("toastr");
require("ab-datepicker/js/locales/da.js");
require("ab-datepicker");
require("locale_da");
var moment = require("moment");

(function () {
    var activeDates = [];
    var firstLoadDates = [];

    $(function () {
        SetupGoBackButton();

        window.BaseUrl = $("#apiurl").val();
        window.IsMobileDevice = isMobileDevice();

        $(".date").datepicker({
            theme: 'bootstrap',
            firstDayOfWeek: 1,
            outputFormat: 'dd-MM-yyyy',
            modal: true,
            isDateDisabled: function (date) {
                var dateAsString = moment(date).format("DD-MM-YYYY");
                return activeDates.indexOf(dateAsString) === -1;
            }
        });

        //Notificationer beskeder
        if (window.successMessage !== undefined && window.successMessage.length > 0) {
            var successMessages = window.successMessage.split(";");
            for (var i = 0; i < successMessages.length; i++) {
                window.showSuccessNotification(successMessages[i]);
            }

        }
        if (window.infoMessage !== undefined && window.infoMessage.length > 0) {
            var infoMessages = window.infoMessage.split(";");
            for (var k = 0; k < infoMessages.length; k++) {
                window.showInfoNotification(infoMessages[k]);
            }
        }
        if (window.errorMessage !== undefined && window.errorMessage.length > 0) {
            var errorMessages = window.errorMessage.split(";");
            for (var j = 0; j < errorMessages.length; j++) {
                window.showErrorNotification(errorMessages[j]);
            }
        }
    });

    window.showSuccessNotification = function (message) {
        toastr.success(message);
    }

    window.showErrorNotification = function (message) {
        toastr.error(message);
    }

    window.showInfoNotification = function (message) {
        toastr.info(message);
    }

    window.setFirstLoadDates = function (dates) {
        firstLoadDates = dates;
    }

    window.loadFirstLoadDates = function () {
        activeDates = firstLoadDates;
    }

    window.addEventListener("activeDatesChanged", function(e) {
        activeDates = e.detail;
    });

})();

function isMobileDevice() {
    return navigator.platform.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i);
}

function GoBack(){
    var publicationSiteUrl = window.location.protocol + "//" + window.location.host;
    if (document.referrer.startsWith(publicationSiteUrl)){
        history.back()
    }
    else {
        window.location = "/"
    }
}

function SetupGoBackButton() {
    document.querySelectorAll("[data-backbutton]").forEach(
        function(element) {
            element.addEventListener("keydown", function(e){
                if (e.key === " " || e.key === 'Enter') {
                    GoBack()
                }
            });
            element.addEventListener("click", function(e){
                GoBack()
            })
    })
}



//////////////////
// WEBPACK FOOTER
// ./Content/scripts/shared.js
// module id = 0
// module chunks = 3